import axiosClient from '../../../api/utils/provider';

export async function getManifest() {
  // Cache-bust so the browser never serves a stale manifest after a post-deploy reload.
  return axiosClient.get(`${window.location.origin}/manifest.json?t=${Date.now()}`);
}
